// CUSTOM AFFIRM LOGIC TO DEAL WITH THEME'S VARIANT LOGIC
try {
  const priceParent = document.getElementsByClassName('product-details-price-snippet')[0];
  const priceElementSelector = '.igPrice';
  var price = document.querySelector(priceElementSelector).innerText;

  const affirmObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      for (var i = 0; i < mutation.addedNodes.length; i++) {
        let textContent = mutation.addedNodes[i].textContent;
        // Check for the element that contains a price
        if (/[$]/g.test(textContent)) {
          let newPriceString = document.querySelector(priceElementSelector).innerText;
          // If price has changed, update Affirm ALA
          if (price != newPriceString) {
            let containsDecimal = newPriceString.includes(".");
            let numbersOnly = newPriceString.replace(/[^0-9]/g, "");
            let priceFloat = parseFloat(numbersOnly);
            let newPrice = containsDecimal ? priceFloat : priceFloat * 100;
            price = newPriceString;
            $('.affirm-as-low-as').attr('data-amount', newPrice);
            affirm.ui.refresh();
          }
        }
      }
    });
  });
  
  affirmObserver.observe(priceParent, { characterData: false, childList: true, attributes: false, subtree: true });
} catch (error) {}